import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronRight, faCommentAltLines } from '@fortawesome/pro-light-svg-icons';
import { CommonModule } from '@angular/common';
import { LabelChipsComponent } from '../label-chips/label-chips.component';


@Component({
  selector: 'app-approval-flow',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, LabelChipsComponent],
  templateUrl: './approval-flow.component.html',
  styleUrl: './approval-flow.component.scss'
})
export class ApprovalFlowComponent {

  @Input() status: 'process' | 'pending' | 'sucess' = 'pending';
  @Input() typeUser:string = "";
  @Input() user:string = "";
  @Input() showLabel:boolean = false;
  @Input() isLast:boolean = false;
  @Input () tituloPopover:string = '';
  @Input () mensajePopover:string = '';
  @Input () positionPopover:'top-left' | 'top-center' | 'top-right' |
    'bottom-left' | 'bottom-center' | 'bottom-right' |
    'left' | 'right' = 'top-center';

  faChevronRight = faChevronRight;
  faCommentAltLines = faCommentAltLines;
  
  get color(): string {
    switch (this.status) {
      case 'process':
        return 'var(--color-primary)';
      case 'pending':
        return 'var(--color-B2)';
      case 'sucess':
        return 'var(--color-sucess)';
      default:
        return 'var(--color-B2)'; 
    }
  }

}
